import {SnackBarActions} from '@store/aviary/aviary.adapter';
import {
  AUTH_PATRON_MISSING_MESSAGE,
  CUSTOM_ERROR_HANDLERS_CREATOR,
  CustomErrorHandlersCreator,
  REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE
} from '@aviary/interceptors/http-error-interceptor.types';
import {HttpContext} from '@angular/common/http';

export function contextWithErrorHandlerForLoadBorrowingHistory(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // failed to find authenticated patron in db
          errorCodes: 'ENTITY_ID_NOT_FOUND',
          actions: SnackBarActions.showError(AUTH_PATRON_MISSING_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForRenew(itemTitle: string): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // checkout not found
          errorCodes: 'ENTITY_ID_NOT_FOUND',
          actions: SnackBarActions.showError(REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE)
        },
        {
          // checkout has outstanding hold
          errorCodes: 'CHECKOUT_RENEW_BLOCKED_HOLD',
          actions: SnackBarActions.showCenteredMultilineError([
            'This item has holds.',
            `${itemTitle} cannot be renewed.`
          ])
        },
        {
          // exceeded a rule with a maximum renewal count, could be global, branch, item, or patron category based
          errorCodes: 'CHECKOUT_RENEW_BLOCKED_CIRC_RULE',
          actions: SnackBarActions.showCenteredMultilineError([
            'Maximum renewals reached.',
            `${itemTitle} was not renewed.`
          ])
        },
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForFileClaim(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // ENTITY_ID_NOT_FOUND: checkout not found
          // GENERAL_INVALID_VALUE: claim already exists on this checkout
          errorCodes: ['ENTITY_ID_NOT_FOUND', 'GENERAL_INVALID_VALUE'],
          actions: SnackBarActions.showError(REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE)
        },
        {
          // invalid checkout state, valid resolutions: LOST, CLAIMED, CHECKED_IN
          errorCodes: 'CHECKOUT_INVALID_STATUS',
          actions: SnackBarActions.showError('Checkout is not in an unresolved state.')
        },
        {
          // missing request claim
          errorCodes: 'GENERAL_MISSING_PARAM',
          actions: SnackBarActions.showError('No claim was submitted.')
        },
        {
          // failed to find authenticated patron in db OR the checkout's patron doesn't match the auth patron
          errorCodes: 'PATRON_INVALID_ID',
          actions: SnackBarActions.showError(AUTH_PATRON_MISSING_MESSAGE)
        },
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}
